import React, { useContext } from 'react'

import { AppNavigatorContext } from 'browser/contexts/app-navigator/app-navigator-context'
import { useLocalStorage } from 'browser/components/hooks/useLocalStorage'
import { InternalViewContext } from './internal-view-context'

const PERSISTENCE_KEY = 'superadminViewsEnabled'

interface IInternalViewProviderProps {
  children: React.ReactNode
}

export function InternalViewProvider(props: IInternalViewProviderProps) {
  const { settings } = useContext(AppNavigatorContext)
  const [enabled, setEnabled] = useLocalStorage<boolean>(PERSISTENCE_KEY, false)

  const showInternals = Boolean(settings?.isAdmin || (settings?.isImpersonating() && enabled))

  return (
    <InternalViewContext.Provider value={{ showInternals, setShowInternals: setEnabled }}>
      {props.children}
    </InternalViewContext.Provider>
  )
}
